// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__2XcHq","modal":"denied_modal__PaM5v","bounce":"denied_bounce__03hP6","overlay":"denied_overlay__We8AW","wrapper":"denied_wrapper__56fk1"};